import { render, staticRenderFns } from "./DoctorEdit.vue?vue&type=template&id=222fb50f&"
import script from "./DoctorEdit.vue?vue&type=script&lang=js&"
export * from "./DoctorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports